export class AdvisorPortalEntryPoint {
  static readonly DASHBOARD = 'dashboard';
  static readonly REFERRALS_PLANNING_EMPTY_STATE = 'referrals_planning_empty_state';
  static readonly REFERRALS_PLANNING_TOP_BUTTON = 'referrals_planning_top_button';
  static readonly ACTIVE_FILES_PLANNING_EMPTY_STATE = 'active_files_planning_empty_state';
  static readonly ARCHIVED_TOP_BUTTON = 'archived_top_button';
  static readonly REFERRALS_SETTLEMENT_EMPTY_STATE = 'referrals_settlement_empty_state';
  static readonly ACTIVE_FILES_SETTLEMENT_EMPTY_STATE = 'active_files_settlement_empty_state';
  static readonly OPPORTUNITIES = 'opportunities';
  static readonly FINANCIALS = 'financials';
  static readonly FAMILY_TREE = 'family_tree';
  static readonly REFERRAL_FLOW = 'referral_flow';
  static readonly TEAMS = 'teams';
  static readonly ONBOARDING = 'onboarding';
  static readonly REFERRALS_PLANNING_HEADER_BUTTON = 'referrals_planning_header_button';
  static readonly NO_SOLUTION_BANNER = 'no_solution_banner';
  static readonly HEADER = 'header';
  static readonly NAV = 'nav';
  static readonly BILLING = 'billing';
  static readonly DOCUMENTS_TAB = 'documents_tab';
  static readonly OPPORTUNITIES_HIGHLIGHTS = 'opportunities_highlights';
}
